import { render, staticRenderFns } from "./dangao.vue?vue&type=template&id=049e6b1e&scoped=true&"
import script from "./dangao.vue?vue&type=script&lang=js&"
export * from "./dangao.vue?vue&type=script&lang=js&"
import style0 from "./dangao.vue?vue&type=style&index=0&id=049e6b1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e6b1e",
  null
  
)

export default component.exports